"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionCheckerUtil = exports.permissionCheckerFn = void 0;
const hasPermission_1 = require("./hasPermission");
const isNonEmptyMenuItem_1 = require("./isNonEmptyMenuItem");
/**
 * @internal
 * This function takes a list and recursively check if the provided session has the correct permissions.
 */
function permissionCheckerFn(session, list = []) {
    return list
        ?.map((el) => {
        if (!(0, hasPermission_1.hasPermission)(session, el))
            return null;
        if (el.items) {
            return {
                ...el,
                items: permissionCheckerFn(session, el.items),
            };
        }
        return el;
    })
        .filter(Boolean);
}
exports.permissionCheckerFn = permissionCheckerFn;
/**
 * This utility is designed to work together with `getMenuConfig()`, but can be used standalone, as long the input follows the same structure.
 *  It return a new config file where all elements not passing the permission check is filtered out.
 * ```ts
 * const filteredConfig = permissionCheckerUtil(session, getMenuConfig())
 * ```
 */
function permissionCheckerUtil(session, config) {
    return { ...config, items: permissionCheckerFn(session, config.items).filter(isNonEmptyMenuItem_1.isNonEmptyMenuItem) };
}
exports.permissionCheckerUtil = permissionCheckerUtil;
